/**
 * Grille de l'accueil (cases régulières façon iOS) : placement des cartes, dans l'ordre de l'utilisateur.
 * Chaque carte occupe `l` colonnes et `h` rangées ; elle prend la première place libre en partant du haut, ce qui
 * comble les trous dès qu'une carte suivante y tient. Sur 4 colonnes, une carte de 2 colonnes ne commence qu'en
 * colonne 1 ou 3 (blocs de 2 × 2 comme sur iOS) : la moitié restante accueille une autre carte large.
 */
export interface TailleCase<T extends string = string> { id: T; l: number; h: number }
export interface PlaceCase { colonne: number; rangee: number }   // à partir de 0

export function placerCases<T extends string>(cases: readonly TailleCase<T>[], colonnes: number): Map<T, PlaceCase> {
  const occupe: boolean[][] = [];
  const libre = (r: number, c: number, l: number, h: number) => {
    for (let y = r; y < r + h; y++) for (let x = c; x < c + l; x++) if (occupe[y]?.[x]) return false;
    return true;
  };
  const places = new Map<T, PlaceCase>();
  for (const k of cases) {
    const l = Math.max(1, Math.min(k.l, colonnes)), h = Math.max(1, k.h);
    const pas = l === 2 && colonnes === 4 ? 2 : 1;
    for (let r = 0; !places.has(k.id); r++) {
      for (let c = 0; c + l <= colonnes; c += pas) {
        if (!libre(r, c, l, h)) continue;
        for (let y = r; y < r + h; y++) for (let x = c; x < c + l; x++) (occupe[y] ??= [])[x] = true;
        places.set(k.id, { colonne: c, rangee: r });
        break;
      }
    }
  }
  return places;
}
